export enum Routes {
  ReportRouter = "*",
  ReportSearchPageRouter = "/report/search",
  FinancialOverviewPageRouter = "/report/financial-overview",
  ReportDetailPageRouter = '/report/:id',
}
